import React from 'react';
import { Field } from 'react-final-form';

import FieldGroup from 'Shared/components/FormComponents/FieldGroup/FieldGroup';

import FormChooseAvatar from './FormChooseAvatar/FormChooseAvatar';

function ChooseAvatarSection() {
  return (
    <FieldGroup label="Upload a profile photo or display initials?" labelClassName="onboarding-form-label pt-3 mb-1">
      <Field name="profile.avatar.url" component={FormChooseAvatar} />
    </FieldGroup>
  );
}

export default ChooseAvatarSection;
